import { render, staticRenderFns } from "./owntable.vue?vue&type=template&id=69a68272&scoped=true"
import script from "./owntable.vue?vue&type=script&lang=js"
export * from "./owntable.vue?vue&type=script&lang=js"
import style0 from "./owntable.vue?vue&type=style&index=0&id=69a68272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a68272",
  null
  
)

export default component.exports